import {frontend} from 'pageflow-scrolled/frontend';

import {Cta} from './Cta';

frontend.contentElementTypes.register('cta', {
  component: Cta
});
